import React, { Fragment } from 'react'
import classNames from "classnames";

export default function Feed({children})
{
    return <div className="flow-root">
        <ul role="list" className="-mb-8">
            {
                children.map((child, index) =>
                    <li key={index}>
                        <div className="relative pb-8">
                            {
                                index !== children.length - 1
                                    ? <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                                            aria-hidden="true"/>
                                    : null
                            }
                            <div className="relative flex items-start space-x-3">
                                {child}
                            </div>
                        </div>
                    </li>
                )
            }
        </ul>
    </div>;
}
